import React from 'react';
import { useStyles } from './styles';
import { StatusIntegrationQueueEnum } from '@/main/services/enum/StatusIntegrationQueueEnum';

interface Props {
  idStatus: StatusIntegrationQueueEnum,
  name: string
}

export default function StatusIntegrationQueue({ idStatus, name }: Props) {
  const classes = useStyles();

  const renderColor = () => {
    switch (idStatus) {
      case StatusIntegrationQueueEnum.Success:
        return '#00cc66';
      case StatusIntegrationQueueEnum.Error:
        return '#ff0000';
      case StatusIntegrationQueueEnum.Discarded:
        return '#949494';
      default:
        return '#949494';
    }
  };
  return (
    <div
      className={`d-flex align-items-center justify-content-center ${classes.container}`}
      title={name}
      style={{ backgroundColor: renderColor() }}
    >
      <span className={classes.spanContainer}>{name}</span>
    </div>
  );
}
